<template lang="html">
  <div class="web-wepper">
    <p class="web-info-tit" @click="goHome">首页 - 订单列表</p>
    <div class="order-web-list">
      <div class="order-nav">
        <div class="" v-for="item in orderList" :key="item.value" :class="{'active' : item.value === navInd}" @click="navBtn(item.value)">
          {{item.title}}
        </div>
      </div>
      <div class="order-list">
        <p class="font-gray" v-show="list && list.length === 0">您还没有订单</p>
        <div class="order-list-item" v-for="(order, index) in list" :key="index" @click="go2detail(order)">
          <p class="code">
            {{order.order_no}}
            <span v-show="order.is_closed * 1 === 1">订单已关闭</span>
            <span v-show="order.status * 1 === 1" class="green">已付款,待确认</span>
            <span v-show="order.status * 1 === 2" class="green">预定成功</span>
            <span v-show="order.status * 1 === 0" class="red">待付款</span>
          </p>
          <div class="rv-max" v-for="(p, i) in order.product" :key="i">
            <div class="img">
              <img :src="p.product_logo" alt="">
            </div>
            <div class="content">
              {{p.product_name}}
            </div>
            <div class="btns">
              <button type="button" name="button" v-show="order.is_closed * 1 === 1" @click.stop="delShow(order, index)">删除订单</button>
              <button type="button" name="button">查看详情</button>
              <button type="button" name="button" v-show="order.is_closed * 1 === 0 && order.status < 2" @click.stop="close(order, index)">取消订单</button>
              <button type="button" name="button" v-show="order.is_closed * 1 === 0 && order.pay_status * 1 === 0" @click.stop="goPay(order)">前往支付</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <confirm v-model="show"
      :title="'确认删除订单吗'"
      @on-confirm="onConfirm"
      confirm-text="删除订单"
      cancel-text="放弃"
      hide-on-blur
      class="toast">
        <p class="toast-txt">一旦删除,订单将无法恢复</p>
      </confirm>

      <confirm v-model="colseShow"
        :title="'确认要取消订单吗'"
        @on-confirm="onConfirms"
        confirm-text="取消订单"
        cancel-text="放弃"
        hide-on-blur
        class="toast">
          <p class="toast-txt">一旦取消,订单将无法恢复</p>
        </confirm>

      <toast v-model="showMsg" type="text" :time="800" is-show-mask :position="'middle'">{{msgTxt}}</toast>
  </div>
</template>

<script>
import OrderService from '../../service/OrderService'
import Confirm from 'vux/src/components/confirm'
import Toast from 'vux/src/components/toast'

export default {
  components: {
    Confirm,
    Toast
  },
  data: () => ({
    list: null,
    orderList: [
      { value: 'all', title: '全部' },
      { value: 0, title: '未付款' },
      { value: 1, title: '已付款' },
      { value: 2, title: '已完成' }
    ],
    navInd: 'all',
    show: false,
    colseShow: false,
    showMsg: false,
    msgTxt: '',
    delData: {
      code: '',
      ind: ''
    },
    closeData: {
      code: '',
      ind: ''
    }
  }),
  methods: {
    async getList () {
      const res = await OrderService.getList({ status: this.navInd, page: 1 })
      if (res.data.data && res.data.code === 1) {
        this.list = res.data.data.list
      }
    },
    go2detail (order) {
      const { order_no } = order
      this.$router.push({ name: 'OrderDetail', query: { order_no } })
    },
    goHome () {
      this.$router.replace({ name: 'Home' })
    },
    navBtn (val) {
      this.navInd = val
      this.getList()
    },
    close (item, index) {
      this.closeData.code = item.order_no
      this.closeData.ind = index
      this.colseShow = true
    },
    delShow (item, index) {
      this.delData.code = item.order_no
      this.delData.ind = index
      this.show = true
    },
    onConfirm () {
      OrderService.doDel({ order_no: this.delData.code }).then(res => {
        if (res.data.code === 1) {
          this.showMsg = true
          this.msgTxt = '已删除'
          this.list.splice(this.delData.ind, 1)
        } else {
          this.showMsg = true
          this.msgTxt = res.data.msg
        }
      })
    },
    onConfirms () {
      OrderService.doCancle({ order_no: this.closeData.code }).then(res => {
        if (res.data.code === 1) {
          this.showMsg = true
          this.msgTxt = '订单已取消'
          this.list[this.closeData.ind].status = 7
          this.list[this.closeData.ind].is_closed = 1
        } else {
          this.showMsg = true
          this.msgTxt = res.data.msg
        }
      })
    },
    goPay (item) {
      // 跳转至订单支付页面
      this.$router.push({ name: 'OrderPay', query: { order_no: item.order_no } })
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style lang="css" scoped>
</style>
